import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import adminAccountingApi from "../services/adminAccountingApi";
import "../styles/Admin.css";

export default function AdminJournalEntriesPage({ adminEmail, onLogout }) {
  const nav = useNavigate();
  const [status, setStatus] = useState({ type: "", msg: "" });
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  async function load() {
    setStatus({ type: "", msg: "" });
    setLoading(true);
    try {
      const res = await adminAccountingApi.listJournalEntries({
        dateFrom: dateFrom || undefined,
        dateTo: dateTo || undefined,
        limit: 100,
        offset: 0,
      });
      if (!res?.ok) throw new Error(res?.error || "load_failed");
      setRows(res.rows || []);
    } catch {
      setStatus({ type: "error", msg: "Unable to load journal entries." });
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="ucx-section">
      <div className="ucx-container ucx-admin-page">
        <div className="ucx-admin-header">
          <div>
            <h1 className="ucx-admin-title">Journal Entries</h1>
            <p className="ucx-admin-subtitle">Accounting ledger postings (read-only)</p>
          </div>

          <div className="ucx-admin-header-right">
            {adminEmail && <span className="ucx-small">Signed in as {adminEmail}</span>}
            <div className="ucx-admin-header-actions">
              <button className="ucx-btn ucx-btn-outline" type="button" onClick={load} disabled={loading}>
                {loading ? "Refreshing…" : "Refresh"}
              </button>
              {typeof onLogout === "function" ? (
                <button type="button" className="ucx-admin-btn ucx-admin-btn-reject" onClick={onLogout}>
                  Sign out
                </button>
              ) : null}
            </div>
          </div>
        </div>

        <div className="ucx-admin-panel">
          <div className="ucx-admin-panel-title">Filters</div>

          <div className="ucx-admin-filters ucx-admin-filters-inventory">
            <input type="date" value={dateFrom} onChange={(e) => setDateFrom(e.target.value)} title="Date From" />
            <input type="date" value={dateTo} onChange={(e) => setDateTo(e.target.value)} title="Date To" />
            <button className="ucx-btn ucx-btn-primary" type="button" onClick={load} disabled={loading}>
              Apply
            </button>
          </div>

          {status.type === "error" ? <div className="ucx-admin-status-error">{status.msg}</div> : null}
        </div>

        <div className="ucx-admin-table-wrapper">
          <table className="ucx-admin-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Entry No</th>
                <th>Date</th>
                <th>Source</th>
                <th>Source ID</th>
                <th>Memo</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr
                  key={r.id}
                  onClick={() => nav(`/accounting/journal-entries/${r.id}`)}
                  style={{ cursor: "pointer" }}
                >
                  <td>{r.id}</td>
                  <td>{r.entry_no}</td>
                  <td>{r.entry_date}</td>
                  <td>{r.source_module || "-"}</td>
                  <td>{r.source_id || "-"}</td>
                  <td>{r.memo || "-"}</td>
                </tr>
              ))}

              {loading && (
                <tr>
                  <td colSpan={6} className="ucx-admin-empty">
                    Loading journal entries…
                  </td>
                </tr>
              )}

              {!loading && rows.length === 0 && (
                <tr>
                  <td colSpan={6} className="ucx-admin-empty">
                    No journal entries found for these filters.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
